import { CHARGES, DIFFICULTE, motDeLEtoile } from '../partage/vocabulaire';
import './EtoilesDeDifficulte.css';

/**
 * « Difficulté pour toi » : cinq étoiles cliquables (chantier `flottaison`, décision d'Igor du
 * 2026-10-01), 1 facile, 5 difficile. Cliquer la troisième allume les trois premières ;
 * re-cliquer celle qui est réglée retire tout (« non réglée »), comme les autres choix de la
 * fiche (`Choix`, `Saisies.tsx`). Au doigt, chaque étoile fait 44 px.
 */
export function EtoilesDeDifficulte({
  valeur,
  onChoisir,
}: {
  valeur: number | null;
  onChoisir: (charge: number | null) => void;
}) {
  return (
    <div className="etoiles" role="group" aria-label={DIFFICULTE}>
      {CHARGES.map((cran) => {
        const allumee = valeur !== null && cran <= valeur;
        return (
          <button
            key={cran}
            type="button"
            className={`etoile${allumee ? ' est-allumee' : ''}`}
            aria-label={motDeLEtoile(cran)}
            aria-pressed={valeur === cran}
            title={motDeLEtoile(cran)}
            onClick={() => onChoisir(valeur === cran ? null : cran)}
          >
            <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
              <path d="M12 2.8l2.75 5.6 6.15.9-4.45 4.35 1.05 6.1L12 16.85 6.5 19.75l1.05-6.1L3.1 9.3l6.15-.9z" />
            </svg>
          </button>
        );
      })}
    </div>
  );
}
